import React, { FC } from 'react';
import styled from 'styled-components';
import { User } from 'api/models';
import { ProjectMember } from 'components/molecules/projects/project-member';
import { Caption01 } from 'components/styles/typography';

const Text = styled.p`
  margin-bottom: 0;
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0;

  & p {
    margin-bottom: 0;
  }
`;

const MemberRole = styled(Text)`
  ${Caption01};
  color: var(--gray-70);
`;

export const MemberDetails: FC<{ member: User; projectId: number }> = ({
  member,
  projectId,
}) => {
  return (
    <Details>
      <ProjectMember projectId={projectId} member={member} />
      {member?.role && <MemberRole>{member.role.roleName}</MemberRole>}
    </Details>
  );
};
